import { render } from "./GameEnd.vue?vue&type=template&id=a45c1842&ts=true"
import script from "./GameEnd.vue?vue&type=script&lang=ts"
export * from "./GameEnd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__